import {useQuery} from '@shopify/react-graphql';
import {isServer} from '@web-utilities/env';
import {useMemo} from 'react';
import * as React from 'react';
import {
  PartialShop,
  ShopContext as ShopContextInterface,
} from '@web-utilities/shop';

import ShopQuery from './graphql/ShopQuery.graphql';

export const ShopContext = ({
  shop,
  children,
}: {
  shop: PartialShop;
  children: React.ReactNode;
}) => {
  const {
    data,
    loading: shopQueryIsLoading,
    error,
  } = useQuery(ShopQuery, {
    ssr: false,
  });

  const contextValues = useMemo(
    () => ({
      ...shop,
      currentThemeId: data?.shop.currentThemeId || '',
      machineTranslationEnabled: data?.shop.machineTranslationEnabled || false,
      machineTranslationLocaleLimit:
        data?.shop.machineTranslationLocaleLimit || 2,
      machineTranslationCustomCredentialsEnabled:
        data?.shop.machineTranslationCustomCredentialsEnabled || false,
      shopEmail: data?.shop.email || '',
      loading: isServer || shopQueryIsLoading,
      features: data?.shop.features || {
        autoSyncSupport: false,
        translatableCookieBanner: false,
      },
      error,
    }),
    [data, error, shop, shopQueryIsLoading],
  );

  return (
    <ShopContextInterface.Provider value={contextValues}>
      {children}
    </ShopContextInterface.Provider>
  );
};
